// main.js

import App from "./App.svelte";
import { initDatabase } from "./db";

// First initialize the database
initDatabase().then((success) => {
  if (success) {
    // Then mount the app
    const app = new App({
      target: document.body,
    });
  } else {
    // Display error message if database initialization fails
    document.body.innerHTML = `
      <div style="text-align: center; margin-top: 100px;">
        <h1>Error</h1>
        <p>Failed to initialize the database. Please make sure your browser supports IndexedDB and try again.</p>
      </div>
    `;
  }
});

export default app;
